import React, { Component } from 'react'
import ScrollToTop from '../../../components/ScrollToTop'
import MenuSider from '../../../components/MenuSider'
import { connect } from 'react-redux'
import IntlMessages from '../../../util/IntlMessages';
import { Carousel } from 'antd';
import 'antd/dist/antd.css';
//import 'bootstrap/dist/css/bootstrap.css';
import './SOHandbook.css';


class SOHandbook extends Component {



    render() {
        return (
            <div>
                <ScrollToTop />
                <MenuSider title={<IntlMessages id="sohandbook.title" />}>
                    <div className="content">
                        <Carousel>

                           

							<div><h3><img src="/images/minimanual/SOT_Manual_2020_001.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_002.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_003.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_004.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_005.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_006.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_007.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_008.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_009.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_010.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_011.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_012.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_013.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_014.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_015.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_016.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_017.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_018.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_019.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_020.Jpg" width="100%"></img></h3></div>
							<div><h3><img src="/images/minimanual/SOT_Manual_2020_021.Jpg" width="100%"></img></h3></div>
							

                        </Carousel>

                    </div>
                </MenuSider>
            </div>
        );
    }
}
const mapStatetoProps = (state) => {
    return {
        detail: state.detail,
        authen: state.authen,
        detailMyOb: state.detailMyOb,
    }
}

export default connect(mapStatetoProps)(SOHandbook)